var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M13.578 14.3v1.333a2.867 2.867 0 0 1-2.867 2.867H6.867a2.867 2.867 0 0 1-2.868-2.867V7.367A2.867 2.867 0 0 1 6.867 4.5h3.844a2.867 2.867 0 0 1 2.867 2.867V8.7M15.79 13.6l1.663-1.58a.717.717 0 0 0 0-1.04L15.79 9.4M17.264 11.5H8.422"
})));
export { SvgLogout as ReactComponent };
export default __webpack_public_path__ + "static/media/logout.ad4ebf1eecaac3a080a0d3520bb0b9b0.svg";